import { createSlice } from "@reduxjs/toolkit";

const puritySlice = createSlice({
    name:"purities",
    initialState:{
        purities:null
    },
    reducers:{
        setPurityList(state,action){
            state.purities = action?.payload;
        },
    }
})


export const {setPurityList} = puritySlice.actions
export default puritySlice.reducer